import { Action, createReducer, on } from '@ngrx/store';
import { setFilterStateGlobalRequirements } from '../actions/state-requirement.actions';
import { ComplianceSelectedArgsState } from '../state/compliance-selected-args.state';

export const initialState: ComplianceSelectedArgsState = {
    args: [],
    error: null
};
const reducer = createReducer(
    initialState,
    on(setFilterStateGlobalRequirements, (state, action) => {
        const stateIdExists = state.args[action.stateId] !== undefined;
        if (stateIdExists) {
            return {
                ...state,
                args: state.args.map((arg, index) => {
                    return index !== action.stateId ? arg : action.filter;
                })
            };
        } else {
            // Create a new array with the new filter at the specified index
            const newArgs = [...state.args];
            newArgs[action.stateId] = action.filter;
            return {
                ...state,
                args: newArgs
            };
        }
    })
);

export function stateSelectedStateArgsReducer(state: ComplianceSelectedArgsState | undefined, action: Action) {
    return reducer(state, action);
}
